// Connect copy of sidekick-web's RecordList, trimmed to what processed calls
// use. The meeting list rows are left out.

import { colors } from "../../style";
import { apiPlaceholder, SENTIMENT } from "../../utils/meetingFormat";
import { Chip } from "../ui";

// Two lines, then an ellipsis
export const clamp = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

// Mouth and brow strokes per face, drawn dark on a filled circle
const FACES = {
  angry: "M16 16.5s-1.5-2-4-2-4 2-4 2M6 6l3.5 1.5M18 6l-3.5 1.5",
  frown: "M16 16.5s-1.5-2-4-2-4 2-4 2",
  meh: "M8 15.5h8",
  smile: "M8 14s1.5 2.5 4 2.5 4-2.5 4-2.5",
  laugh: "M7 13.5h10a5 5 0 0 1-10 0Z",
};

// A filled face in the sentiment colour, so the mood reads at a glance
export function SentimentFace({ rating, size = 16 }) {
  const mood = SENTIMENT[rating];
  if (!mood) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ flex: "none" }}
    >
      <circle cx="12" cy="12" r="11" fill={mood.color} />
      <g
        fill="none"
        stroke={colors.pageBackground}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 10.5h.01M15 10.5h.01" strokeWidth="2.6" />
        <path d={FACES[mood.face]} />
      </g>
    </svg>
  );
}

// sentiment: { rating, summary }. The summary shows as a tooltip, since the
// chip often sits inside a row link. Pass summary null to skip it.
// neutralIfUnknown: show Neutral for a missing or unknown rating.
export function SentimentChip({ sentiment, size, neutralIfUnknown }) {
  const rating =
    SENTIMENT[sentiment?.rating] || !neutralIfUnknown ? sentiment?.rating : 3;
  const mood = SENTIMENT[rating];
  if (!mood) return null;
  const note = apiPlaceholder(sentiment?.summary) ? null : sentiment?.summary;
  return (
    <Chip color={mood.color} title={note || undefined} size={size}>
      <SentimentFace rating={rating} size={size === "sm" ? 16 : 18} />
      {mood.label}
    </Chip>
  );
}
